import { call, put, delay } from "redux-saga/effects";
import { isSubscribedAction, unsubscribeActions } from "../slices";
import { subscriptionAPI } from "@services/api/";
import { toast } from "react-toastify";
import { showFailureToast } from "@helpers";

function* unsubscribeWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(unsubscribeActions.pending());
    const response = yield call(subscriptionAPI.unsubscribe, payload);
    yield put(unsubscribeActions.success(response));
    yield put(isSubscribedAction(payload));
    // TODO: handle callback | onSuccess
  } catch (error) {
    showFailureToast("Unsubscribe Fail!");
    yield put(unsubscribeActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { unsubscribeWorker };
